import Section from '../Section';
import BannerSectionStyle3 from '../Section/BannerSection/BannerSectionStyle3';
import ProfileCard from '../Profile/ProfileCard';

const Profile = () => (<>
    <BannerSectionStyle3
        bgUrl="/images/about/banner_bg.svg"
        imgUrl="/images/about/banner_img.png"
        title="Profile"
        subTitle="User information"
    />
    <Section
        topMd={170}
        topLg={150}
        topXl={110}
        bottomMd={200}
        bottomLg={150}
        bottomXl={110}
    >
        <ProfileCard />
    </Section>
</>);

export default Profile;
